import intercom from '../core/intercom'
import extract, {sanitize} from '../core/extract'
import providerErrors from '../provider/errors'
import workflowErrors from '../workflow/errors'
import referenceErrors from '../reference/errors'
import messageErrors from '../message/errors'
import claimErrors from '../claim/errors'
import satisfactionErrors from '../satisfaction/errors'
import i18n from './i18n'

var TEXT_COLOR = '#8a959a'
var TEXT_COLOR_DARK = '#546D79'

var BG_COLOR = '#F5F5F5'
var BORDER_COLOR = '#DADADA'

var I18N = {
    fatalError: 'Erreur système',
    fatalErrorText: [
        'L\'application rencontre des difficultés techniques.',
        'Veuillez réessayer ou contacter le support si le problème persiste.'
    ],
    backToHome: 'Retour à l\'accueil'
}

function renderFatalErrorPage() {

    var css = '' +
    '.fatalerror {' +
    '   position: fixed;' +
    '   top: 0;' +
    '   bottom: 0;' +
    '   left: 0;' +
    '   right: 0;' +
    '   z-index: 1100;' +
    '   background: ' + BG_COLOR + ';' +
    '}' +
    '.fatalerror-content {' +
    '   margin: 15px;' +
    '   padding: 20px;' +
    '   border: 1px solid ' + BORDER_COLOR + ';' +
    '   background: #FFFFFF;' +
    '   text-align: center;' +
    '   color: ' + TEXT_COLOR + ';' +
    '}' +
    '.fatalerror-content h1 {' +
    '   margin-bottom: 50px;' +
    '   text-transform: uppercase;' +
    '   color: ' + TEXT_COLOR_DARK + ';' +
    '}' +
    '@media (min-width: 768px) {' +
    '   .fatalerror-content {' +
    '       width: 50%;' +
    '       margin-top: 200px;' +
    '       margin-left: auto;' +
    '       margin-right: auto;' +
    '   }' +
    '}'
 
    var html =  '' + 
    '<div class="fatalerror-content">' +
    '   <h1>' + I18N.fatalError + '</h1>' +
        I18N.fatalErrorText.map((text) => (
    '       <p>' + text + '</p>'
        )).join('') +
    '   <a href="/">' + I18N.backToHome + '</a>' +
    '</div>'

    var cssElement = document.createElement('style')
    cssElement.type = 'text/css'
    if (cssElement.styleSheet) {
        // IE10 and below
        cssElement.styleSheet.cssText = css
    } else {
        cssElement.innerText = css    
    }
    document.body.appendChild(cssElement)

    var htmlElement = document.createElement('div')
    htmlElement.className = 'fatalerror'
    htmlElement.innerHTML = html
    document.body.appendChild(htmlElement)
}

function appErrors(error) {
    return extract(i18n.errorTypeEnum, error.type, null)
}

export function errorHandler(message, source, line, col, error) {
    if (!error || !error.statusCode) {
        // handle only unexpected errors
        console && console.error(error || message)
        renderFatalErrorPage()
        intercom('trackEvent', 'app-crashed', {
            error: error && error.name || message,
            message: error && error.message,
            stack: error && error.stack,
            source: source,
            line: line,
            column: col,
            useragent: window.navigator.userAgent
        })
    }
}

export function unhandledRejectionHandler(event) {
    const reason = event.reason

    if (!reason || !reason.statusCode) {
        // handle only unexpected errors
        console && console.error(reason)
        renderFatalErrorPage()
        intercom('trackEvent', 'app-crashed', {
            error: reason && reason.name,
            message: reason && reason.message,
            stack: reason && reason.stack,
            useragent: window.navigator.userAgent
        })
    }
}

export default function(error, getState) {
    var result
    if (result = providerErrors(error, getState)) return result
    if (result = workflowErrors(error)) return result
    if (result = referenceErrors(error)) return result
    if (result = messageErrors(error)) return result
    if (result = claimErrors(error)) return result
    if (result = satisfactionErrors(error)) return result
    if (result = appErrors(error)) return result
    return sanitize(error.type)
}


// WEBPACK FOOTER //
// ./lib/app/errors.js